import { useCallback, useEffect, useState } from "react";
import { AthleteFields } from "./AthleteFields";
import { Categories } from "../../services/contants/Categories";
import { Departments } from "../../services/contants/Departments";
import { useLocation, useNavigate } from "react-router-dom";

export const AthleteFilters = ({
  field,
  filter,
  setFilter,
  useSearchParams,
}) => {
  const [fullname, setFullname] = useState(filter.fullname ?? "");

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (useSearchParams && location.search) {
      const params = new URLSearchParams(location.search);
      const fullname = params.get("fullname");
      if (fullname && fullname.length > 3) {
        if (filter.fullname !== fullname) {
          setFilter({ ...filter, fullname: fullname });
        }
      } else {
        if (filter.fullname !== undefined) {
          setFilter({ ...filter, fullname: undefined });
        }
      }
      setFullname(fullname);
      [
        "firstname",
        "lastname",
        "gender",
        "category",
        "club_name",
        "department",
      ].forEach((key) => {
        const value = params.get(key);
        if (filter[key] !== value) {
          setFilter({ ...filter, [key]: value });
        }
      });
    }
  }, [useSearchParams, location, setFilter, filter, setFullname]);

  const updateFilter = useCallback(
    (key, value) => {
      if (useSearchParams) {
        const params = new URLSearchParams(location.search);
        params.set(key, value);
        navigate(`${location.pathname}?${params.toString()}`);
      } else {
        if (key === "fullname") {
          if (value.length > 3) {
            setFilter({ ...filter, [key]: value });
          } else if (filter.fullname) {
            setFilter({ ...filter, [key]: undefined });
          }
        } else {
          setFilter({ ...filter, [key]: value });
        }
      }
    },
    [useSearchParams, location, navigate, filter, setFilter]
  );

  // useEffect(() => {
  //   //on met à jour le search params
  //   const params = new URLSearchParams(location.search);
  //   if (
  //     filter.fullname &&
  //     useSearchParams &&
  //     params.get("fullname") !== filter.fullname
  //   ) {
  //     params.set("fullname", filter.fullname);
  //     navigate(`${location.pathname}?${params.toString()}`);
  //   }
  // }, [useSearchParams, filter, location.pathname, navigate]);

  switch (field) {
    case AthleteFields.lastname:
      return (
        <input
          type="text"
          className="form-control form-control-sm"
          value={filter.lastname ?? ""}
          placeholder="Nom"
          onChange={(e) => updateFilter("lastname", e.target.value)}
        />
      );
    case AthleteFields.firstname:
      return (
        <input
          type="text"
          className="form-control form-control-sm"
          value={filter.firstname ?? ""}
          placeholder="Prénom"
          onChange={(e) => updateFilter("firstname", e.target.value)}
        />
      );
    case AthleteFields.fullname:
      return (
        <input
          type="text"
          className="form-control form-control-sm"
          value={fullname ?? ""}
          placeholder="Nom complet (au moins 3 caractères)"
          onChange={(e) => {
            setFullname(e.target.value);
            updateFilter("fullname", e.target.value);
          }}
        />
      );
    case AthleteFields.gender:
      return (
        <select
          className="form-control form-control-sm"
          value={filter.gender ?? ""}
          onChange={(e) => updateFilter("gender", e.target.value)}
        >
          <option value="">Tous</option>
          <option value="m">M</option>
          <option value="f">F</option>
        </select>
      );
    case AthleteFields.category:
      return (
        <select
          className="form-control form-control-sm"
          value={filter.category ?? ""}
          onChange={(e) => updateFilter("category", e.target.value)}
        >
          <option value="">Tous</option>
          {Object.keys(Categories).map((category) => (
            <option value={category}>{category}</option>
          ))}
        </select>
      );
    case AthleteFields.club:
      return (
        <input
          type="text"
          className="form-control form-control-sm"
          value={filter.club_name ?? ""}
          placeholder="Club"
          onChange={(e) => updateFilter("club_name", e.target.value)}
        />
      );
    case AthleteFields.department:
      return (
        <select
          className="form-control form-control-sm"
          value={filter.department ?? ""}
          onChange={(e) => updateFilter("department", e.target.value)}
        >
          <option value="">Tous</option>
          {Departments.map((department) => (
            <option value={department} key={department}>
              {department}
            </option>
          ))}
        </select>
      );
    default:
      return null;
  }
};
